var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.67 0H2.34A1.34 1.34 0 0 0 1 1.33v11.34A1.34 1.34 0 0 0 2.34 14h7.33A1.34 1.34 0 0 0 11 12.67V1.33A1.34 1.34 0 0 0 9.67 0M10 12.67a.33.33 0 0 1-.33.33H2.34a.33.33 0 0 1-.34-.33V9h8ZM10 8H2V1.33A.33.33 0 0 1 2.34 1h7.33a.33.33 0 0 1 .33.33Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6.01,
  cy: 11,
  r: 1,
  fill: "currentColor"
})));
export default SvgPhone;